"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatdata = void 0;
/**
 * 格式化数据
 */
function formatdata(opts, data) {
    var arr_yaxis = data;
    /** 过滤掉不符合的数据 */
    var newarr = arr_yaxis.filter(function (val) {
        if (val !== undefined && val !== "" && val !== " " && val !== "-") {
            return true;
        }
    });
    var yAxisMax = 0, yAxisMin = 0, x_scale = 1, y_scale = 1, yPointUnit = 0;
    if (!!newarr.length) {
        var min = Math.min.apply(Math, newarr);
        var max = Math.max.apply(Math, newarr);
        var diff = max - min;
        if (diff != 0) {
            yAxisMax = max + diff * 0.1;
            yAxisMin = min - diff * 0.1;
        }
        else {
            if (max == 0) {
                yAxisMax = max + 1;
                yAxisMin = min - 1;
            }
            else {
                yAxisMax = max + Math.abs(max * 0.05);
                yAxisMin = min - Math.abs(max * 0.05);
            }
        }
        x_scale = (opts.width - opts.padding.l - opts.padding.r) / data.length;
        y_scale = (opts.height - opts.padding.t - opts.padding.b) / (yAxisMax - yAxisMin);
        // yPointUnit =(yAxisMax-yAxisMin)/opts.split.y
        yPointUnit = (opts.height - opts.padding.t - opts.padding.b) / (opts.yaxis.pointnum - 1);
    }
    return {
        yPointWidth: opts.padding.l,
        x_scale: x_scale,
        y_scale: y_scale,
        yAxisMax: yAxisMax,
        yAxisMin: yAxisMin,
        yPointUnit: yPointUnit,
    };
}
exports.formatdata = formatdata;
